<template>
	<TabWrapper @change="change" @save="submit" @deploy:preview="$emit('deploy:preview')"
							@deploy:live="$emit('deploy:live')">
		<v-container fluid>
			<v-row>
				<v-col cols="12" lg="4" ref="list">
					<div v-if="$vuetify.breakpoint.lgAndUp">
						<div class="d-flex align-center">
							<Input v-model.trim="search"
										 class="mx-4 mb-4"
										 label="Suche"
										 :hideDetails="true"
										 append-icon="mdi-magnify"
							></Input>
							<TooltipIcon :color="ada.darkGrey"
													 @click="toggleZoneListWidth"
													 :tooltip="'Liste '+ (expandList ?'verkleinern':'erweitern')">
								{{
									expandList ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal'
								}}np
							</TooltipIcon>
						</div>
						<List style="height:488px">
							<v-list-item v-for="(item, i) in modules" :key="i" @click="selectModule(item)"
													 :class="active(item)">
								<v-list-item-icon title="Zone löschen">
									<v-icon left :color="(item.isEnabled || item.isEnabled === 1 ? 'green' : 'red')">
										{{ item.isEnabled || item.isEnabled === 1 ? 'mdi-check' : 'mdi-close' }}
									</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="font-weight-regular" :title="item.Name.length > 20 ? item.Name : ''">
										<span>{{ item.Name }}</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</List>
					</div>
					<div v-else>
						<v-autocomplete
							class="mt-4"
							:items="modules"
							label="Module"
							item-text="Name"
							item-value="Name"
							:readonly="readOnly"
							:color="ada.blue"
							flat
							return-object
							no-data-text="Keine Daten"
							@change="selectModule($event)"
						>
						</v-autocomplete>
					</div>
				</v-col>
				<v-col cols="12" lg="8" ref="content">
					<div class="borderContainer ml-lg-4" :class="[$vuetify.breakpoint.name]">
						<transition name="fade" mode="out-in">
							<div v-if="loading || selectedModule === null" :key="0"
									 class="d-flex justify-center align-center"
									 style="width:100%;height: 350px;">
								<v-progress-circular v-if="loading" :size="50" :color="ada.pink" indeterminate
								></v-progress-circular>
								<div v-if="selectedModule === null" class="noSiteSelected">
									Bitte ein Modul zum Bearbeiten auswählen.
								</div>
							</div>
							<div v-else :key="1" class="px-lg-6">
								<div class="d-flex flex-wrap">
									<div style="width:400px">
										<Input v-model="selectedModule.Name" label="Modulbezeichnung"
													 :disabled="true"></Input>
									</div>
									<Toggle v-model="isEnabled"
													label="Modul aktiv"
													:disabled="readOnly" class="ml-6"></Toggle>
								</div>
								<v-row no-gutters>
									<v-col>
										<div class="pr-6 text-h6 font-weight-regular">JSON Konfiguration</div>
										<AceEditor
											v-model="json_content"
											@init="editorInit"
											lang="json"
											theme="chrome"
											width="100%"
											height="450"
											:options="aceConfig"
											:commands="[{name: 'save', bindKey: { win: 'Ctrl-s', mac: 'Command-s' }, exec: submit}]"
										/>
									</v-col>
								</v-row>
							</div>
						</transition>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Input from "../../../components/Inputs/Input";
import AceEditor from 'vuejs-ace-editor';
import ada from "../../..//scss/ada_colors.scss";
import Utils from "../../../scripts/Utils";
import Toggle from "../../../components/buttons/Toggle";
import List from "../../../components/List";
import TooltipIcon from "../../../components/TooltipIcon";

export default {
	name: "Modules",
	components: {TooltipIcon, List, Toggle, Input, TabWrapper, AceEditor},
	props: ['readOnly'],
	data: () => {
		return {
			search: null,
			json_content: null,
			loading: false,
			key: 0,
			isEnabled: false,
			expandList: true,
			ada
		}
	},
	mounted() {
		this.init();
		this.$emit('activeComponent', this);
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		selectedModule() {
			return this.vuexState.selectedModule;
		},
		moduleDetails() {
			return this.vuexState.moduleDetails;
		},
		modules() {
			if (this.siteDetails) {
				if (this.search && this.search !== '' && this.$vuetify.breakpoint.lgAndUp) {
					return this.siteDetails.Module.filter(x => x.Name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
				} else {
					return this.siteDetails.Module;
				}
			}
			return [];
		},
		activeTab() {
			return this.$store.state.display.activeTab;
		},
		aceConfig() {
			let ret = this.$store.state.aceConfig;
			ret.readOnly = this.readOnly;
			return ret;
		},
	},
	methods: {
		init() {
			if (this.selectedModule) {
				this.isEnabled = this.moduleDetails.Module.Isenabled;
				this.json_content = Utils.htmlDecode(this.moduleDetails.Module.Config);
			}
		},
		fetchModuleDetails() {
			if (this.selectedModule) {
				this.loading = true;
				this.$store.dispatch('display/fetchModuleDetails', {
					module_id: this.selectedModule.ModuleId
				}).then(() => {
					this.loading = false;
				});
			} else {
				this.$store.commit('display/setModuleDetails', {data: null});
			}
		},
		selectModule(item) {
			this.$store.commit('display/setSelectedModule', item);
		},
		active(item) {
			if (this.selectedModule && this.selectedModule.ModuleId === item.ModuleId) {
				return 'active';
			} else {
				return ''
			}
		},
		editorInit() {
			require('brace/ext/searchbox'); //language extension prerequsite...
			require('brace/ext/language_tools'); //language extension prerequsite...
			require('brace/mode/json');    //language
			require('brace/snippets/json')
			require('brace/theme/chrome');
		},
		submit() {
			if (Utils.isJsonString(this.json_content)) {
				this.$emit('submit', this);
			} else {
				this.$emit('snackbar', 'Die angegebene Konfiguration ist keine valide JSON.', true);
			}
		},
		change() {
			if (this.$store.state.display.previousTab === this.$options._componentTag) {
				this.$emit('change', this);
			} else if (this.activeTab === this.$options._componentTag) {
				this.$emit('activeComponent', this);
			}
		},
		dataChanged() {
			let changed = false;
			if (this.selectedModule &&
				(this.isEnabled !== this.moduleDetails.Module.Isenabled ||
					this.json_content !== this.moduleDetails.Module.Config.replaceAll("\r", ""))) {
				changed = true;
			}
			return changed;
		},
		getBody() {
			return {
				publisher_id: this.siteDetails.Site.PublisherId,
				site_id: this.siteDetails.Site.SiteId,
				type_id: this.siteDetails.Current.SitetypeId,
				module_id: this.moduleDetails.module_id,
				Isenabled: this.isEnabled,
				Config: this.json_content
			}
		},
		toggleZoneListWidth() {
			this.expandList = !this.expandList;
			if (this.expandList) {
				this.$refs.list.classList.replace('col-lg-3', 'col-lg-4');
				this.$refs.content.classList.replace('col-lg-9', 'col-lg-8');
			} else {
				this.$refs.list.classList.replace('col-lg-4', 'col-lg-3');
				this.$refs.content.classList.replace('col-lg-8', 'col-lg-9');
			}
		}
	},
	watch: {
		selectedModule() {
			this.fetchModuleDetails();
		},
		moduleDetails() {
			this.init();
		},
		siteDetails() {
			this.$store.commit('display/setSelectedModule', null);
			this.fetchModuleDetails();
		}
	}
}
</script>

<style lang="scss" scoped>
.borderContainer {
	&.lg, &.xl {
		border-left: 1px solid rgba(0, 0, 0, .12);
	}

	&.xs, &.sm, &.md {
		border-top: 1px solid rgba(0, 0, 0, .12);
	}

	&.sm, &.md {
		padding-top: 24px;
		margin-top: 16px;
	}

	&.xs {
		padding-top: 20px;
		margin-top: 10px;
	}
}
</style>